/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

let frontRowSiHeading = document.querySelector('.landing-product.frontRowSi .product-meta__title');

if (frontRowSiHeading != null) {
    let newText = frontRowSiHeading.innerText.slice(0, frontRowSiHeading.innerText.length - 1);
    newText = newText.toUpperCase();
    newText += 'i';
    frontRowSiHeading.innerText = newText;

}

const tabs = document.querySelectorAll('.product-details-navigation-li');
if (tabs.length > 0) {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelector('.product-details-navigation-li').classList.add('product-details-navigation-active');
        document.querySelector('.product-details-content-block').classList.remove('display-none');
        document.querySelector('.product-details-content-block').classList.add('product-details-content-active');

        document.querySelector('.product-details-content-wrapper').style.maxHeight = `${document.querySelector(`#product-details-content-${document.querySelector('.product-details-navigation-active').getAttribute('data-tab-link-id')}`).offsetHeight + 40}px`;

    })

    let tabSelectionInProgress = false;
    for (let i = 0; i < tabs.length; i++) {
        tabs[i].addEventListener('click', function() {
            if (this.classList.contains('product-details-navigation-active') || tabSelectionInProgress) {
                return;
            }

            tabSelectionInProgress = true;
            document.querySelector('.product-details-navigation-active').classList.remove('product-details-navigation-active');
            const currentActiveContent = document.querySelector('.product-details-content-active')
            currentActiveContent.classList.remove('product-details-content-active');
            this.classList.add('product-details-navigation-active');
            setTimeout(() => {
                currentActiveContent.classList.add('display-none');
                document.querySelector(`#product-details-content-${this.getAttribute('data-tab-link-id')}`).classList.remove('display-none');
                document.querySelector('.product-details-content-wrapper').style.maxHeight = `${document.querySelector(`#product-details-content-${this.getAttribute('data-tab-link-id')}`).offsetHeight +40}px`;

                setTimeout(() => {
                    document.querySelector('#product-details-content-' + this.getAttribute('data-tab-link-id')).classList.add('product-details-content-active');
                    tabSelectionInProgress = false;

                }, 100);
            }, 550);


        })
    }
}
const copyButton = document.querySelector('.product-meta__share-button-item--copy-button');

if (copyButton) {
    copyButton.addEventListener('click', function(e) {
        e.preventDefault();
        var copyText = window.location.href;
        navigator.clipboard.writeText(copyText);
        var tooltip = document.getElementById("myTooltip");
        tooltip.innerHTML = "Link Copied";
    });

    copyButton.addEventListener('mouseout', function() {
        var tooltip = document.getElementById("myTooltip");
        tooltip.innerHTML = "Copy to clipboard";
    });
}


    function setInputFilter(textbox, inputFilter) {
        [
            "input",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "select",
            "contextmenu",
            "drop",
        ].forEach(function(event) {
            textbox.addEventListener(event, function() {
                if (inputFilter(this.value)) {
                    this.oldValue = this.value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                } else if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue;
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                } else {
                    this.value = "";
                }
            });
        });
    }

    function addToInput(inputElement) {
        if (inputElement.value === '') {
            inputElement.value = 0;
        }
        inputElement.value = +inputElement.value + 1;
    }

    function removeFromInput(inputElement) {
        if (inputElement.value === '') {
            inputElement.value = 0;
        } else if (+inputElement.value != 0) {
            inputElement.value = +inputElement.value - 1;
        }
    }
    //Apply function to each of the inputs
    document.querySelectorAll(".number-field").forEach((field) => {
        setInputFilter(field, function(value) {
            return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
        });
        field.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowUp') {
                addToInput(e.target);
            } else if (e.key === 'ArrowDown') {
                removeFromInput(e.target)
            }
        })
    });

document.querySelectorAll('.veg-container .water-usage-input .water-buttons-group a').forEach(button=>{
  button.addEventListener('click', (e)=>{
    e.preventDefault();
    if(e.target.classList.contains('veg-water-increment')){
      addToInput(document.querySelector('#veg-gallons-week'));
    }else if(e.target.classList.contains('veg-water-substraction')){
      removeFromInput(document.querySelector('#veg-gallons-week'));
    }
  })
})

document.querySelectorAll('.veg-container .ec-input .water-buttons-group a').forEach(button=>{
  button.addEventListener('click', (e)=>{
    e.preventDefault();
    if(e.target.classList.contains('veg-water-increment')){
      addToInput(document.querySelector('#ec-week-veg'));
    }else if(e.target.classList.contains('veg-water-substraction')){
      removeFromInput(document.querySelector('#ec-week-veg'));
    }
  })
})

document.querySelectorAll('.flow-container .water-usage-input .water-buttons-group a').forEach(button=>{
  button.addEventListener('click', (e)=>{
    e.preventDefault();
    if(e.target.classList.contains('flow-water-increment')){
      addToInput(document.querySelector('#flow-gallons-week'));
    }else if(e.target.classList.contains('flow-water-substraction')){
      removeFromInput(document.querySelector('#flow-gallons-week'));
    }
  })
})

document.querySelectorAll('.flow-container .ec-input .water-buttons-group a').forEach(button=>{
  button.addEventListener('click', (e)=>{
    e.preventDefault();
    if(e.target.classList.contains('flow-water-increment')){
      addToInput(document.querySelector('#ec-week-flow'));
    }else if(e.target.classList.contains('flow-water-substraction')){
      removeFromInput(document.querySelector('#ec-week-flow'));
    }
  })
})



    let addAllProductsToCart,
        loadingAnimationUndergoing = false,
        addedToCart = false;
    const handleLoading = function(show, goBackToInitialState) {
        const addAllToCartBtnText = document.querySelector('#add-all-to-cart .regular-add-to-cart-text');
        const addAllToCartSpinner = document.querySelector('#add-all-to-cart .loader-button__loader');
        const addAllToCartHeadToCart = document.querySelector('#add-all-to-cart .view-cart');
        if (show && !loadingAnimationUndergoing) {
            loadingAnimationUndergoing = true;
            addAllToCartBtnText.classList.add('hidden');
            setTimeout(() => {
                addAllToCartSpinner.classList.add('show');
            }, 300);
          } else if (!show && goBackToInitialState){
          	loadingAnimationUndergoing = false;
            addAllToCartSpinner.classList.remove('show');
            setTimeout(() => {
                addAllToCartBtnText.classList.remove('hidden');
            }, 300);
          } else if (!show) {
            loadingAnimationUndergoing = false;
            addAllToCartSpinner.classList.remove('show');
            setTimeout(() => {
                document.querySelector('#add-all-to-cart').classList.add('goToCart');
                addAllToCartHeadToCart.classList.add('show');
            }, 300);
        }
    }

    let addedToCartMsgAnimationOngoing = false;
    const displayAddedToCartMsg = (show,msg,overThousand) => {
        if (!addedToCartMsgAnimationOngoing) {
            addedToCartMsgAnimationOngoing = true;
            const addedToCartMsg = document.querySelector('#added-to-cart-msg');
            const addedToCartMsgOverlay = document.querySelector('#added-to-cart-msg-overlay');
            if (show) {
          		addedToCartMsg.querySelector('.message').innerHTML = msg;
          		if(overThousand){
					addedToCartMsg.querySelector('.regular-msg').classList.add('hidden');
          			addedToCartMsg.querySelector('.over1000-msg').classList.remove('hidden');
                }else{
					addedToCartMsg.querySelector('.regular-msg').classList.remove('hidden');
          			addedToCartMsg.querySelector('.over1000-msg').classList.add('hidden');
                }
                addedToCartMsg.classList.remove('display-none');
                addedToCartMsgOverlay.classList.remove('display-none');
                setTimeout(() => {
                    addedToCartMsgOverlay.classList.remove('hidden');
                    setTimeout(() => {
                        addedToCartMsg.classList.remove('hidden');
                        addedToCartMsgAnimationOngoing = false;
                    }, 200);
                }, 50);
            } else {
                addedToCartMsg.classList.add('hidden');
                setTimeout(() => {
                    addedToCartMsgOverlay.classList.add('hidden');
                    setTimeout(() => {
                        addedToCartMsg.classList.add('display-none');
                        addedToCartMsgOverlay.classList.add('display-none');
                        addedToCartMsgAnimationOngoing = false;
                    }, 500);
                }, 200);
            }
        }
    }
	
    document.querySelectorAll('#added-to-cart-msg .close-msg').forEach(closeBtn => {
        closeBtn.addEventListener('click', e => {
            displayAddedToCartMsg(false);
        });
    });
	document.querySelector('#added-to-cart-msg .signMeUpBtn').addEventListener('click', e => {
          window.location.href = 'https://solsticeag.method.ws/apps/Public.aspx#/628471c8-4121-4d85-85d8-5594f814ee31/WFBrVzNfdlpLNFFlOERzdkgzeGU5US0t';
	});
    document.querySelector('#added-to-cart-msg .no-thanks-btn').addEventListener('click', e => {
            displayAddedToCartMsg(false);
	});
          

    document.querySelector(".input-fields").addEventListener("submit", (e) => {
        e.preventDefault();
        const ecVeg = +document.querySelector('#ec-week-veg').value;
        const ecFlow = +document.querySelector('#ec-week-flow').value;
        const vegWeek = +document.querySelector('.veg-radio:checked').value;
        const vegWeeklyWater = +document.querySelector('#veg-gallons-week').value;
        const flowWeek = +document.querySelector('.flow-radio:checked').value;
        const flowWeeklyWater = +document.querySelector('#flow-gallons-week').value;
        let frontRowSiVegParam,frontRowSiFlowParam;

        if(ecVeg>3.5){
          frontRowSiVegParam = 0;
        }else if(ecVeg===3.5){
          frontRowSiVegParam = 0.125;
        }else if(ecVeg>=2.7){
          frontRowSiVegParam = 0.25;
        }else if(ecVeg>=2.3){
          frontRowSiVegParam = 0.333;
        }else{
          frontRowSiVegParam = 0.5;
        }
      
        if(ecFlow>3.5){
          frontRowSiFlowParam = 0;
        }else if(ecFlow===3.5){
          frontRowSiFlowParam = 0.125;
        }else if(ecFlow>=2.7){
          frontRowSiFlowParam = 0.25;
        }else if(ecFlow>=2.3){
          frontRowSiFlowParam = 0.333;
        }else{
          frontRowSiFlowParam = 0.5;
        }

        let partA = (vegWeek * ecVeg *  vegWeeklyWater *2.033) + (flowWeek * ecFlow * flowWeeklyWater * 1.578),
            partB = (vegWeek * ecVeg * vegWeeklyWater *1.355) + (flowWeek * ecFlow * flowWeeklyWater * 1.052),
            bloom = (flowWeek * ecFlow * flowWeeklyWater * 1.242),
            frontRowSi = (vegWeek*frontRowSiVegParam*vegWeeklyWater)+(flowWeek*frontRowSiFlowParam*flowWeeklyWater),
            cleanUp = (vegWeek*0.2*vegWeeklyWater)+(flowWeek*0.2*flowWeeklyWater),
            triologic = (vegWeek*(0.2*vegWeeklyWater))+(flowWeek*(0.2*flowWeeklyWater));

        let triologicMl = Math.ceil(triologic),
            leftTriologic = triologicMl,
            triologic500 = 0,
            triologic1G = 0,
            triologic2_5G = 0;

        while(leftTriologic > 0){
          if(triologic1G === 0 && triologic2_5G===0){
            leftTriologic -= 500
            triologic500++;
            if(triologic500 === 7){
              triologic500 = 0;
              triologic1G += 1;
            }
          }else if(triologic1G != 0 && triologic2_5G===0){
            triologic500 = 0;
            leftTriologic -= 500*7;
            triologic1G += 1;
            if(triologic1G > 2){
              triologic500 = 0;
              triologic1G = 0;
              triologic2_5G++;
            }
          }else if(triologic2_5G!=0){
            triologic500 = 0;
            triologic1G = 0;
            triologic2_5G++;
            leftTriologic -= 500*7*2.5;
          }
        }


        let partAGram = Math.ceil(partA),
            partA5 = Math.ceil(partA/2267.96)>5 ? 0 : Math.ceil(Math.ceil(partA)/2267.96)%5,
            partA25 = Math.ceil(partA/2267.96)>=5 ? Math.ceil((Math.ceil(partA)/2267.96) / 5) : 0,
            partBGram= Math.ceil(partB),
            partB5= Math.ceil(partB/2267.96)>5 ? 0 : Math.ceil(Math.ceil(partB)/2267.96)%5,
            partB25= Math.ceil(partB/2267.96)>=5 ? Math.ceil((Math.ceil(partB)/2267.96) / 5) : 0,
            bloomGram= Math.ceil(bloom),
            bloom5= Math.ceil(bloom/2267.96)>5 ? 0 : Math.ceil(Math.ceil(bloom)/2267.96)%5,
            bloom25= Math.ceil(bloom/2267.96)>=5 ? Math.ceil((Math.ceil(bloom)/2267.96) / 5):0,
            cleanUpGram= Math.ceil(cleanUp),
            cleanUp5= Math.ceil(cleanUp/2267.96)>5 ? 0 : Math.ceil(Math.ceil(cleanUp)/2267.96)%5,
            cleanUp25= Math.ceil(cleanUp/2267.96)>=5 ? Math.ceil((Math.ceil(cleanUp)/2267.96) / 5) : 0,
            frontRowSiMl= Math.ceil(frontRowSi),
            frontRowSi1Q=  Math.ceil(frontRowSi/946.353)>4 ? 0 : Math.ceil(Math.ceil(frontRowSi)/2267.96)%5,
            frontRowSi1G= Math.ceil(frontRowSi/946.353)>=4 ? Math.ceil((Math.ceil(frontRowSi)/946.353) / 4) : 0;
            triologicMl= triologicMl,
            triologic500= triologic500,
            triologic1G=triologic1G,
            triologic2_5G=triologic2_5G;
        let partARow = document.querySelector('.partARow'),
            partBRow = document.querySelector('.partBRow'),
            bloomRow = document.querySelector('.bloomRow'),
            cleanUpRow = document.querySelector('.cleanUpRow'),
            frontRowSiRow = document.querySelector('.frontRowSiRow'),
            triologicRow = document.querySelector('.triologicRow');
        partARow.querySelector('.weight-quantity').innerHTML = partAGram + 'g';
        partARow.querySelector('.quantity1').innerHTML = partA5;
        partARow.querySelector('.quantity2').innerHTML = partA25;

        partBRow.querySelector('.weight-quantity').innerHTML = partBGram + 'g';
        partBRow.querySelector('.quantity1').innerHTML = partB5;
        partBRow.querySelector('.quantity2').innerHTML = partB25;

        bloomRow.querySelector('.weight-quantity').innerHTML = bloomGram + 'g';
        bloomRow.querySelector('.quantity1').innerHTML = bloom5;
        bloomRow.querySelector('.quantity2').innerHTML = bloom25;

        /*
        cleanUpRow.querySelector('.weight-quantity').innerHTML = cleanUpGram + 'g';
        cleanUpRow.querySelector('.quantity1').innerHTML = cleanUp5;
        cleanUpRow.querySelector('.quantity2').innerHTML = cleanUp25;
        */

        frontRowSiRow.querySelector('.weight-quantity').innerHTML = frontRowSiMl + 'mL';
        frontRowSiRow.querySelector('.quantity1').innerHTML = frontRowSi1Q;
        frontRowSiRow.querySelector('.quantity2').innerHTML = frontRowSi1G;

        triologicRow.querySelector('.weight-quantity').innerHTML = triologicMl + 'mL';
        triologicRow.querySelector('.quantity1').innerHTML = triologic500;
        triologicRow.querySelector('.quantity2').innerHTML = triologic1G;
        triologicRow.querySelector('.quantity3').innerHTML = triologic2_5G;

        document.querySelector('.estimator-container').classList.add('show');
        setTimeout(() => {
            document.querySelector('.results').style.display = 'flex';
            setTimeout(() => {
                document.querySelector('.results').classList.add('show')
            }, 100);
        }, 1000);

        let addingToCart = false;

        addAllProductsToCart = async () => {
            if (!addingToCart && !addedToCart) {
                addingToCart = true;
                handleLoading(true);
                let formData = {
                        items: []
                    },
                    totalItemsPrice = 0;

                if (partA5 != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.partA.variant1.id,
                        quantity: partA5
                    });
                    totalItemsPrice += +productsOfInterestPrices.partA.variant1.price * partA5;
                }
                if (partA25 != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.partA.variant2.id,
                        quantity: partA25
                    });
                    totalItemsPrice += +productsOfInterestPrices.partA.variant2.price * partA25;
                }


                if (partB5 != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.partB.variant1.id,
                        quantity: partB5
                    });
                    totalItemsPrice += +productsOfInterestPrices.partB.variant1.price * partB5;
                }
                if (partB25 != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.partB.variant2.id,
                        quantity: partB25
                    });
                    totalItemsPrice += +productsOfInterestPrices.partB.variant2.price * partB25;
                }
                if (bloom5 != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.bloom.variant1.id,
                        quantity: bloom5
                    });
                    totalItemsPrice += +productsOfInterestPrices.bloom.variant1.price * bloom5;
                }
                if (bloom25 != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.bloom.variant2.id,
                        quantity: bloom25
                    });
                    totalItemsPrice += +productsOfInterestPrices.bloom.variant2.price * bloom25;
                }
                if (cleanUp5 != 0 && productsOfInterestPrices.cleanup?.variant1?.id) {
                    formData.items.push({
                        id: productsOfInterestPrices.cleanUp.variant1.id,
                        quantity: cleanUp5
                    });
                    totalItemsPrice += +productsOfInterestPrices.cleanUp.variant1.price * cleanUp5;
                }
                if (cleanUp25 != 0 && productsOfInterestPrices.cleanup?.variant2?.id) {
                    formData.items.push({
                        id: productsOfInterestPrices.cleanUp.variant2.id,
                        quantity: cleanUp25
                    });
                    totalItemsPrice += +productsOfInterestPrices.cleanUp.variant2.price * cleanUp25;
                }

                if (frontRowSi1Q != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.frontRowSi.variant1.id,
                        quantity: frontRowSi1Q
                    });
                    totalItemsPrice += +productsOfInterestPrices.frontRowSi.variant1.price * frontRowSi1Q;
                }

                if (frontRowSi1G != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.frontRowSi.variant2.id,
                        quantity: frontRowSi1G
                    });
                    totalItemsPrice += +productsOfInterestPrices.frontRowSi.variant2.price * frontRowSi1G;
                }

                if (triologic500 != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.triologic.variant1.id,
                        quantity: triologic500
                    });
                    totalItemsPrice += +productsOfInterestPrices.triologic.variant1.price * triologic500;
                }
                if (triologic1G != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.triologic.variant2.id,
                        quantity: triologic1G
                    });
                    totalItemsPrice += +productsOfInterestPrices.triologic.variant2.price * triologic1G;
                }

                if (triologic2_5G != 0) {
                    formData.items.push({
                        id: productsOfInterestPrices.triologic.variant3.id,
                        quantity: triologic2_5G
                    });
                    totalItemsPrice += +productsOfInterestPrices.triologic.variant3.price * triologic2_5G;
                }
                    const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                      body: JSON.stringify(formData),
                      method: "POST",
                      headers: {
                        "Content-type": "application/json"
                      }
                    });
                    const responseJson = await response.json();
                    if (response.ok) {
                      setTimeout(() => {
                        handleLoading(false);
                        addingToCart = false;
                        addedToCart = true;

                        document.dispatchEvent(new CustomEvent("variant:added", {
                          bubbles: true,
                          detail: {
                            variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
                          }
                        }));
                        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                                                                                 const cartContent = await response2.json();
                        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                          bubbles: true,
                          detail: {
                            cart: cartContent
                          }
                        }));
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                             bubbles: true
                        }));
                      });
                        if (totalItemsPrice < 1000) {
                            displayAddedToCartMsg(true, "Your products have been added to the cart successfully.", false);
                        }else{
                          displayAddedToCartMsg(true, "You qualify for bulk discounts!<br>Register for a sales rep to unlock your savings.", true);
                        }	
  /*
                        setTimeout(()=>{
                                   handleLoading(false, true);	
                        addingToCart = false;
                      },1250);
                      */
					  }, 1000);
					}

                  
            } else if (addedToCart) {
                window.location.href = 'https://' + window.Shopify.shop + '/cart';
            }

        }
    });


    document.querySelector('#add-all-to-cart').addEventListener('click', (e) => {
        e.preventDefault();
        addAllProductsToCart();
    })

	
    const openModalBtn = document.querySelector('#calculator-popup-button');
	const openModalNavBtns = document.querySelectorAll('.usage-estimator-nav-link');
    const closeModalBtn = document.querySelector('#modalClose');
    const usageEstimator = document.querySelector('#usage-estimator');
    const mainContent = document.querySelector('#main');
    const mainBody = document.querySelector('body');
    let animationInProgress = false,
        modalOpen = false;

    const isChildOf = (element, parentToCheck) => {
        while (element != mainBody && element != document.querySelector('html')) {
            if (element === parentToCheck)
                return true;
            element = element.parentElement;
        }
        return false;
    }


	
    const openModal = () => {
        if (!animationInProgress) {
            animationInProgress = true;
            usageEstimator.classList.toggle('hidden');
            setTimeout(() => {
                usageEstimator.classList.toggle('closed');
                mainContent.classList.toggle('modalOpened');
                mainBody.classList.toggle('modalOpened');
                animationInProgress = false;
                modalOpen = true;
                document.addEventListener('mousedown', e => {
                    if (!isChildOf(e.target, usageEstimator) && modalOpen) {
                        closeModal();
                    }
                })
            }, 10);
        }
    }

    const closeModal = () => {
        if (!animationInProgress) {
            animationInProgress = true;
            usageEstimator.classList.toggle('closed');
            mainContent.classList.toggle('modalOpened');
            mainBody.classList.toggle('modalOpened');

            setTimeout(() => {
                usageEstimator.classList.toggle('hidden');
                animationInProgress = false;
                modalOpen = false;
            }, 1000);
        }
    }
    if(openModalBtn){
      openModalBtn.addEventListener('click', e => {
        e.preventDefault();
        openModal();
      })
    }

    openModalNavBtns.forEach(btn=>{
      btn.addEventListener('click', e=>{
        console.log(btn);
        if(btn.classList.contains('mobile-nav__item')){
           document.querySelector('mobile-navigation .drawer__close-button').click();
			console.log(document.querySelector('mobile-navigation .drawer__close-button'));
           setTimeout(()=>{
				e.preventDefault();
        		openModal();         
		    },500);
    	}else{
			e.preventDefault();
			openModal();                   
		}
      });
    });

    closeModalBtn.addEventListener('click', e => {
        e.preventDefault();
        closeModal();
    })
    
    
    if(window.location.hash === '#usage-estimator'){
      openModal();
      
    }
	


